/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useRef } from 'react';
import { checkTokenExpiry, getRefreshToken } from '../../../common/utilities/AuthHelperUtil.js';
import { useMsal } from  '@azure/msal-react';
import { Box } from '@mui/material';
import { CommonModal } from '../../../components';
import constants from '../../../constants';

const ExpirationComponent = () => {
    const  interval  =  useRef(null);
    const {instance, accounts} = useMsal();
    const [showModal, setShowModal] = useState(false);

    const renewSession = async () => {
        setShowModal(false);
        getRefreshToken(instance, accounts);
    }

    useEffect(() => {
        const checkToken  = () => {
            const accountExists = (accounts && accounts.length > 0) || instance.getActiveAccount?.();
            if (accountExists) {
                const isExpired = checkTokenExpiry(instance, accounts);
                if(isExpired) {
                    setShowModal(true);
                }
            }
        };
        interval.current  =  setInterval(checkToken, 60000); // every minute
        return () =>  clearInterval(interval.current);
    }, []);

    return (
        <Box>
            {showModal && (
                <CommonModal type={constants.expire} action={renewSession}/>
            )}
        </Box>    
    );
}

export default ExpirationComponent;
